import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PencilIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M2.772 11.5V14h2.5l7.374-7.373-2.5-2.5L2.772 11.5ZM14.58 4.693c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 0 0-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22Z" />
  </Icon>
);

export default memo(PencilIcon);
